module.exports = __webpack_public_path__ + "static/clarahu-b058e5fc6749ff1ddc51a5d7f6fcc2e4.jpg";